// apps/web/src/admin/AdminSystemHealthView.tsx
import { useEffect, useState } from 'react';
import { apiAdmin } from './apiAdmin.js';

export function AdminSystemHealthView() {
  const [data, setData] = useState<any | null>(null);
  async function refresh() { setData(await apiAdmin.systemHealth()); }
  useEffect(() => { void refresh(); }, []);
  return (
    <div className="space-y-4">
      <button className="btn" onClick={refresh}>Refresh</button>
      {data ? (
        <div className="grid grid-cols-2 gap-4">
          <div className="p-4 rounded border">Supabase: {data.supabaseOk ? 'OK' : 'DOWN'}</div>
          <div className="p-4 rounded border">LiveKit rooms: {data.liveKitRooms}</div>
          <div className="p-4 rounded border col-span-2">Backend version: {data.backendVersion}</div>
          {data.liveKitErrors?.length ? (
            <div className="p-4 rounded border col-span-2">
              <div className="text-sm font-medium mb-2">LiveKit errors</div>
              <pre className="text-xs">{JSON.stringify(data.liveKitErrors, null, 2)}</pre>
            </div>
          ) : null}
        </div>
      ) : <p>Loading…</p>}
    </div>
  );
}
